import * as React from "react";
import Tab from "@mui/material/Tab";

interface PropType {
  label: string;
  selected?: boolean;
}

class LytNavLinkTab extends React.Component<PropType> {
  render() {
    return (
      <Tab className="lytNavLinkTab" value={this.props.label} {...this.props} />
    );
  }
}

export default LytNavLinkTab;
